import CardBody from "components/common/CardBody";
import Column from "components/common/Column";
import CustomCard from "components/common/CustomCard";
import Row from "components/common/Row";
import React from "react";
import { FaCheckToSlot } from "react-icons/fa6";
import WarningIcon from '@mui/icons-material/Warning';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import LockIcon from '@mui/icons-material/Lock';

const MissionStatistics = ({ statistics }) => {
    return (
        <React.Fragment>
            <CustomCard className='w-100 shadow-none'>
                <CardBody>
                    <Row>
                        <Column className='d-flex'>
                            <h5>Total Processes:</h5>
                            <p className="m-0 ms-2">{statistics.total}</p>
                        </Column>
                    </Row>
                    <div className="d-flex mx-5">
                        <InfoCard title="Completed" statistic={statistics.completed} icon={<FaCheckToSlot style={{ fontSize: "34px" }} className="me-5 pt-2" />} />
                        <InfoCard title="Requiring Action" statistic={statistics.required_action} icon={<WarningIcon style={{ fontSize: "34px" }} className="me-5 pt-2" />} />
                        <InfoCard title="Awaiting Completion" statistic={statistics.awaiting_complition} icon={<HourglassBottomIcon style={{ fontSize: "34px" }} className="me-5 pt-2" />} />
                        <InfoCard title="Skipped" statistic={statistics.skipped_action} icon={<i className="fa-solid fa-share me-5 pt-2" style={{ transform: "rotate(90deg)", fontSize: '24px', color: '#528BC0' }}></i>} />
                        <InfoCard title="Locked" statistic={statistics.unavailable} icon={<LockIcon style={{ fontSize: "34px" }} className="me-5 pt-2" />} />
                    </div>
                </CardBody>
            </CustomCard>
        </React.Fragment>
    );
}

MissionStatistics.defaultProps = {
    statistics: {},
};

const InfoCard = ({ statistic, title, icon }) => {
    return <div
        className="d-block m-2 rounded text-dark py-6 px-10 w-100"
        style={{
            backgroundColor: "#F2F2F2",
        }}
    >
        <div className={statistic?.class_name ?? ''}>
            <div className="d-flex py-2">
                {icon}
                <span className="text-dark fw-bold fs-2x">
                    {statistic?.count}
                    {/* ({statistic?.percentage}) */}
                </span>
            </div>
            <span className="text-dark fs-4">{title}</span>
        </div>
    </div>
}

export default MissionStatistics;